(function () {
    'use strict';

    angular
        .module('appback')
        .controller('TarjetalecturaController', TarjetalecturaController)

    TarjetalecturaController.$inject = ["Upload", "$scope", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce"];

    function TarjetalecturaController(Upload, $scope, $http, $timeout, $uibModal, $log, $document, $sce) {
        var vm = this;
        vm.fieldName = "";
        vm.value = { ficheros: [] };

        vm.camposActual = "";
        vm.borrarFichero = function (index) {
            console.log("borrarFichero", index);
            vm.value.ficheros.splice(index, 1);
            $scope.$parent.$parent.control.camposActual[vm.fieldName] = JSON.stringify(vm.value);
        }
        vm.init = function () {
            console.log("init", vm.fieldName);
            if (angular.isDefined($scope.$parent.$parent.control.camposActual[vm.fieldName]) && $scope.$parent.$parent.control.camposActual[vm.fieldName] != '') {
                vm.value = JSON.parse($scope.$parent.$parent.control.camposActual[vm.fieldName]);
            }
            vm.camposActual = $scope.$parent.$parent.control.camposActual;
        }
        vm.uploadFiles = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: '/backend/contacto/readcard',
                        data: { file: files[i] }
                    }).then(function (resp) {
                        //onsole.log(resp);
                        vm.value.ficheros.push(resp.data);

                        $scope.$parent.$parent.control.camposActual[vm.fieldName] = JSON.stringify(vm.value);

                        var camposActual = $scope.$parent.$parent.control.camposActual;

                        // Función auxiliar para asignar valor solo si el campo está vacío
                        function asignarSiVacio(campo, valor) {
                            if (!camposActual[campo] || camposActual[campo] === '') {
                                camposActual[campo] = valor;
                            }
                        }

                        // Asignar valores solo si los campos están vacíos
                        asignarSiVacio("_campo_nombre_1", resp.data.result.nombre);
                        asignarSiVacio("_campo_apellidos_1", resp.data.result.apellidos);
                        asignarSiVacio("_campo_cargo_1", resp.data.result.cargo);
                        asignarSiVacio("_campo_telefono_1", resp.data.result.telefono);
                        asignarSiVacio("_campo_email_1", resp.data.result.email);
                        asignarSiVacio("_campo_empresa_1", resp.data.result.empresa);

                        console.log("camposActual", camposActual);

                        //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                    }, function (resp) {
                        //console.log('Error status: ' + resp.status);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    });
                }

            }
        }
        /*$timeout(function(){
            console.log("vm",$scope);
            $scope.$parent.$parent.control.camposActual["_campo_notas_1"] = "HGOLA";

        },2000)
        //$scope.$parent.cc.camposActual;
        console.log("filespedido");*/
    }

})();